<template>
  <div :class="$style.container">
    <button
      v-for="{key, alphabet} in buttons"
      :key="key"
      @click="handleClick(key)"
      v-long-press="1000"
      @long-press-start="handleLongPressStart(key)"
      @long-press-stop="handleLongPressStop">{{key}} <span v-if="alphabet">{{alphabet}}</span></button>
    <slot name="key"></slot>
    <template v-if="dialButtons">
      <button @click="$emit('phone')"><font-awesome-icon :icon="faPhone" flip="horizontal" /></button>
      <button @click="$emit('mobile')"><font-awesome-icon :icon="faMobileAlt" /></button>
    </template>
  </div>
</template>

<script>
import { setTimeout } from 'window'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
import { faMobileAlt } from '@fortawesome/pro-light-svg-icons/faMobileAlt'

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    dialButtons: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      faPhone,
      faMobileAlt,
      enteredKeys: '',
      buttons: [
        {key: '1', alphabet: null},
        {key: '2', alphabet: 'abc'},
        {key: '3', alphabet: 'def'},
        {key: '4', alphabet: 'ghi'},
        {key: '5', alphabet: 'jkl'},
        {key: '6', alphabet: 'mno'},
        {key: '7', alphabet: 'pqrs'},
        {key: '8', alphabet: 'tuv'},
        {key: '9', alphabet: 'wxyz'},
        {key: '*', alphabet: null},
        {key: '0', alphabet: '+'},
        {key: '#', alphabet: null}
      ],
      longPressing: false
    }
  },
  methods: {
    handleClick (key) {
      if (this.longPressing) {
        return
      }

      this.enteredKeys = this.enteredKeys + key
      this.$emit('input', {
        key,
        keys: this.enteredKeys
      })
    },
    handleLongPressStart (key) {
      this.longPressing = true

      if (key === '0') {
        this.enteredKeys = this.enteredKeys + '+'
        this.$emit('input', {
          key: '+',
          keys: this.enteredKeys
        })
      }
    },
    handleLongPressStop () {
      setTimeout(() => {
        this.longPressing = false
      }, 0)
    }
  }
}
</script>

<style module lang="less" src="./Dialpad.less"></style>



// WEBPACK FOOTER //
// Dialpad.vue?31596ef4